<template>
    <div class="v2-retailer-orders__row">
        <div class="v2-retailer-orders__cell-left">
            <router-link
                :to="{
                    name: 'supplierOrdersID',
                    params: { id: order.OrderID }
                }"
            >
                <div class="v2-retailer-orders__name">
                    Заказ от
                    {{ getFormattedDate(order.RegDate, 'DD MMMM YYYY') }}
                </div>
                <div class="v2-retailer-orders__number">
                    №{{ order.OrderNo }}
                </div>
            </router-link>
            <div class="v2-retailer-orders__price">
                ~ {{ getFormattedNum(orderTotalPrice.toFixed(2) || 0) }} ₽
                <span class="pl-3"
                    >{{ order.items.length }}
                    {{
                        getNounByNum(order.items.length, [
                            'изделие',
                            'изделия',
                            'изделий'
                        ])
                    }}</span
                >
            </div>
            <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
                <div
                    v-for="(orderBrand, i) in orderBrands"
                    :key="i"
                    class="cabinet__catalog-tag"
                >
                    <a>{{ orderBrand }}</a>
                </div>
            </div>
        </div>
        <div class="v2-retailer-orders__cell-right">
            <a
                v-for="photo of orderPhotos"
                :key="photo.ItemID"
                href="javascript:void(0)"
            >
                <img class="v2-retailer-orders__img ofi" :src="photo.url" />
            </a>
        </div>
    </div>
</template>

<script>
import getFormattedDate from '@/utils/getFormattedDate'
import getFormattedNum from '@/utils/getFormattedNum'
import getNounByNum from '@/utils/getNounByNum'

export default {
    name: 'SupplierOrderListItem',
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    computed: {
        orderPhotos() {
            return this.order.items.map(item => item.images[0]).slice(-5)
        },
        orderBrands() {
            return this.order.items.reduce((acc, item) => {
                if (!acc.includes(item.brand.BrandName)) {
                    acc.push(item.brand.BrandName)
                }
                return acc
            }, [])
        },
        orderTotalPrice() {
            return this.order.items.reduce((acc, item) => {
                let price =
                    parseInt(item.pivot.Quantity) * parseFloat(item.pivot.Price)

                //если цена за грамм
                if (parseInt(item.PriceUnit) == 2) {
                    price = price * parseInt(item.Weight)
                }

                return acc + price
            }, 0)
        }
    },
    methods: {
        getFormattedDate,
        getFormattedNum,
        getNounByNum
    }
}
</script>
